/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';

import { LocationBusinessService } from '../../resources/location-business.service';
import { LocationDetailsDialogComponent } from './location-details-dialog.component';

export const locationDetailsDialog = createDialogRoute({
  component: LocationDetailsDialogComponent,
  init: LocationBusinessService,
});
